import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { ConfigContext } from '../context/GlobalContext';
import { useContext, useEffect } from "react";
import AgencyUserListLayer from "../components/AgencyUserListLayer";
import SyncReferralMapping from "../data/Firebase/User/SyncReferralMapping";
import GetUserDataFirebase from "../data/Firebase/User/GetUserDataFirebase";


export const AgencyMembersAddPage = () => {
    const { state, dispatch } = useContext(ConfigContext);

    useEffect(() => {
        const syncData = async () => {
            if (state?.USERID) {
                const userdata = await GetUserDataFirebase(state.USERID);
                SyncReferralMapping(state.USERID, userdata, dispatch);
            }
        };
        syncData();
    }, [state?.USERID, state?.SET_USER]);

    return (
        <MasterLayout>

            {/* Breadcrumb */}
            <Breadcrumb title={"Agency Member"} />
            <AgencyUserListLayer businessData={state?.BUSINESSES} />

        </MasterLayout>
    );
};
